module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAMAAADImI+JAAAANlBMVEUAK38HMYMIMoMgRo8qTpQsUJUyVZhEZKFQbqdSb6hcd61rhLWfr8/P1+fYri3p7fT4+fv///9ibpwjAAAAQUlEQVR42u3KJxIAIBAEsKUevfz/swwCzSoU0cH3WCPx8XDWOhB8rjV7Ipo+Zze4UmnHpHAlZYwiIIQYAyha460FTxcFtzxKzWMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/nr.png
// module id = 897
// module chunks = 0